module.exports = __webpack_public_path__ + "static/media/calendar.7844ae2c.svg";